import CommercialStagingForm from "./CommercialStagingForm"

const BuisnessCardForm = () => {
    return(
        <CommercialStagingForm unitPrice={32} form_name="Business Card Service" />
    )
}

export default BuisnessCardForm;